var _polygon, _path, _path2, _path3, _line, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveEnvelopeGore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "25.52 33.89 24.07 33.89 24.07 6.76 31.29 14.72 31.29 21.4 25.52 33.89",
    fill: "#fbba00",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.23,37.79v2.94h-2.46v-2.94h2.46M27.23,35.79h-6.46v6.94h6.46v-6.94h0Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.99,8.31c10.74,0,13.04,7.54,11.18,12.24-2.5,6.31-5.35,10.13-9.63,14.65h-3.08c-4.18-4.65-7.36-8.81-9.63-14.65-1.83-4.71.44-12.24,11.18-12.24M23.99,6.31c-6.92,0-10.31,2.83-11.94,5.21-1.93,2.81-2.35,6.55-1.1,9.76,2.36,6.07,5.58,10.34,10.01,15.27l.6.66h4.84l.59-.62c4.34-4.58,7.37-8.55,10.04-15.29,1.26-3.18.85-6.91-1.07-9.73-1.63-2.39-5.02-5.24-11.97-5.24h0Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.02,35.48s-6.4-10.83-6.4-17.67c0-4.64,3.88-8.91,6.05-10.4",
    fill: "none",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 8.09,
    x2: 24,
    y2: 35.48,
    fill: "none",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.97,35.48s6.4-10.83,6.4-17.67c0-4.64-3.88-8.91-6.05-10.4",
    fill: "none",
    stroke: "#030303",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveEnvelopeGore);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-envelope-gore.9cc82ca0cb4c1ceb2221f53436425ef0.svg";
export { ForwardRef as ReactComponent };